---
fr:
  budget_actions:
    create_custom_budget: Créer un budget personnalisé
    learn_more: Comment les prévisions sont-elles calculées?
    update_import: Mettre à jour les données budgétaires
  budget_export:
    export_button: Exporter les données budgétaires
  budget_grouping:
    display: Affichage
    view_by: Afficher par
  budget_import:
    description: Exportez les données budgétaires, modifiez-les dans Excel et importez le fichier XLSX mis à jour ici. Les centrales sont en colonnes, les mois sont en lignes. Le système détectera automatiquement l'année à partir de la ligne 4.
    invalid_file_type: Seuls les fichiers XLSX sont pris en charge
    upload_error: Erreur lors de l'importation des données budgétaires
    upload_success: Données budgétaires importées avec succès
    upload_success_with_details: "%{count} enregistrements budgétaires importés avec succès pour l'année %{year}"
  budget_source:
    actual_budgets: Affichage des données budgétaires réelles
    actual_message: Ces données reflètent la production et les revenus réels du passé.
    actual_title: Affichage des données budgétaires réelles
    forecasted_budgets: Affichage des données budgétaires prévues
    forecasted_message: Ce sont des projections calculées basées sur des modèles historiques. Créez un budget personnalisé pour utiliser vos propres valeurs.
    forecasted_title: Affichage des données budgétaires prévues
    imported_budgets: Affichage des données budgétaires futures importées
    imported_message: Vous avez téléchargé des données budgétaires pour cette année.
    imported_title: Affichage des données budgétaires importées
  budgets_for: Budget pour
  dialog:
    new_budget_forecast: Nouvelles prévisions de budget
    unavailable_price_areas: "%{price_areas} ont déjà été créées. Cliquez sur 'Profil de production' pour modifier"
  errors:
    messages:
      budget_already_saved: Le budget a déjà été enregistré !
      no_forcasts_for_this_year: Pas de prévisions pour %{year}
      total_percent: le pourcentage total doit être exactement de 100
  profile:
    average: Moyenne
    price_chart: Graphique des prix
    price_profile: Profil de prix
    production_profile: Profil de production
    production_profile_chart: Graphique du profil de production
    revenue_chart: Graphique des revenus
    revenue_profile: Profil de revenu
    save_budget: Enregistrer le budget
    total: Total
    validations:
      non_negative: Ne peut pas être négatif
      required: Requis
